import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Anderson Acevedo
 * 
 * @version jdesk_1.01.0003
 */
/**
 * CustomSaldosPorUbicacion
 **/
class CustomSaldosPorUbicacion extends FormJaivana.form {

    constructor(props) {

        super(props);
        this.initForm = this.initForm.bind(this);


        this.limpiarCampos = this.limpiarCampos.bind(this);
        this.gridOptionsComponentes = Object.assign({}, this.gridOptions);
        this.onSelectionChangedPrincipal                                  = this.onSelectionChangedPrincipal.bind(this);
        this.gridOptionsComponentes['onSelectionChanged']           = this.onSelectionChangedPrincipal;

        this.mostrarMensajeNoHayDatos = this.mostrarMensajeNoHayDatos.bind(this);
        this.mostrarMensajeAdicional = this.mostrarMensajeAdicional.bind(this);
        this.mostrarMensajeGenerando = this.mostrarMensajeGenerando.bind(this);
        this.traerPropiedades = this.traerPropiedades.bind(this);
        this.sucesstraerPropiedades = this.sucesstraerPropiedades.bind(this);

        this.sucessActualizar = this.sucessActualizar.bind(this);
        this.trasladarTodo = this.trasladarTodo.bind(this);
        this.succesTraerDatos = this.succesTraerDatos.bind(this);

        //imprimir

        this.mostrarMensajeEmailFallo                         =this.mostrarMensajeEmailFallo.bind(this);
        this.mostrarMensajeEmailEnviado                         =this.mostrarMensajeEmailEnviado.bind(this);


        this.currencyFormatterGeneral = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo = this.formatNumberSaldo.bind(this);
        this.sucursal_ingreso = '';
        this.numero_decimales = 2;
        this.trasladar=false;
    }

    initForm() {
        console.log('Formulario CustomSaldosPorUbicacion,  @version: jdesk_1.01.0003, @author:Anderson Acevedo');
        this.sucursal_ingreso = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;
        this.traerPropiedades();

        this.getField('nombre_articulo').setOnChange((props) => {
            this.limpiarCampos();
        });

        this.getField('ubicacion_origen').setOnChange((props) => {
            this.limpiarCampos();
        });

        this.getField('bt_consultar_referencia').setClick(()=>{
            this.limpiarCampos();
            this.traerDatos('referencia');
        });

        this.getField('bt_consultar_ubicacion').setClick(()=>{
            this.limpiarCampos();
            this.traerDatos('ubicacion');
        });


        this.getField('bt_trasladar').setClick(()=>{
            this.trasladarTodo();
        });

    }


    traerDatos(opcion)
    {
        this.getField('codigo_articulo').setError(false,'');
        this.getField('nombre_articulo').setError(false,'');
        this.getField('ubicacion_origen').setError(false,'');
        let datos={ datos: {  }};
        if(opcion==='referencia'){
            if(this.getField('select_ubicaciones').valid() && this.getField('codigo_articulo').valid() && this.getField('nombre_articulo').valid()){
                datos={ datos: { 
                    select_ubicaciones:this.getField('select_ubicaciones').getValue(), 
                    codigo_articulo:this.getField('codigo_articulo').getValue(), 
                    sucursal_ingreso:this.sucursal_ingreso,
                    value:'referencia',
                 }};
            }else{
                this.mostrarMensajeAdicional('Existe un campo vacío o mal configurado.');
                return;
            }
        }else{//ubicacion
            if(this.getField('select_ubicaciones').valid() && this.getField('ubicacion_origen').valid()){
                datos={ datos: { 
                    select_ubicaciones:this.getField('select_ubicaciones').getValue(), 
                    ubicacion_origen:this.getField('ubicacion_origen').getValue(), 
                    sucursal_ingreso:this.sucursal_ingreso,
                    value:'ubicacion',
                }};
            }else{
                this.mostrarMensajeAdicional('Existe un campo vacío o mal configurado.');
                return;
            }
        }
        this.mostrarMensajeGenerando();
        this.getField("rejilla").setTipoServicioOperacion('inve-saldosporubicacion-1_saldos');
        this.getField("rejilla").sendRequest(this.succesTraerDatos, datos); 
    }

    succesTraerDatos(data)
    {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200)
        {
            this.getField('rejilla').toggle(true);
            this.gridOptionsComponentes['rowData'] = data.data;

            let configCell = new Map();
            configCell.set('cantidad', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad) }, cellStyle: {textAlign:"right"}});
            configCell.set('saldo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo) }, cellStyle: {textAlign:"right"}});

            this.getField('rejilla').initData(this.gridOptionsComponentes, configCell);
            if(this.wms_nuevo!=='S'){
                this.getField('bt_trasladar').setVisible(true);
                this.getField('ubicacion_destino').setValue('');
                this.getField('ubicacion_destino').setVisible(true);
            }
        }
        else 
        {
           if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
           }
           /*else {
              let respuesta=Object.values(data.data.errores);
              let keys=Object.keys(data.data.errores);

              this.alertGeneral.toggle(true, 'Error ' +keys + ' - ' + respuesta, 'error');
           }*/
       }
    }


    onSelectionChangedPrincipal(){

    }


    trasladarTodo(){
        this.getField('codigo_articulo').setError(false,'');
        this.getField('nombre_articulo').setError(false,'');
        this.getField('ubicacion_origen').setError(false,'');
        this.getField('ubicacion_destino').setError(false,'');
        if(this.getField('select_ubicaciones').valid() && 
        this.getField('ubicacion_origen').valid() &&
        this.getField('ubicacion_destino').valid()){
            if(this.getField('ubicacion_origen').getValue()!==this.getField('ubicacion_destino').getValue()){
                this.mostrarMensajeGenerando();
                let datos={ datos: {
                    sucursal_ingreso:this.sucursal_ingreso,
                    ubicacion_origen :this.getField('ubicacion_origen').getValue(),
                    ubicacion_destino :this.getField('ubicacion_destino').getValue(),
                    select_ubicaciones :this.getField('select_ubicaciones').getValue(),
                }};
                this.generalFormatPmv = { tipo_servicio: 'inve-saldosporubicacion', operacion: 'trasladar', operacion_tipo: 'crear' };
                this.service.send(
                {
                        endpoint: this.constant.formConfiguration(),
                        method:'POST',
                        body: datos,
                        success: this.sucessActualizar,
                        error: this.error_,
                        general: this.generalFormatPmv,
                        showMessage: false
                });
            }else{
                this.mostrarMensajeAdicional('Las ubicaciones origen y destino son iguales.')   
            }
        }else{
            this.mostrarMensajeAdicional('Existe un campo vacío o mal configurado.');
        }
    }

    sucessActualizar(data) {
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){
            if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }if(data.data.mensaje_mostrar_2!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar_2);
                this.limpiarCampos();//ocultar campos
                this.getField('codigo_articulo').setValue('');
                this.getField('nombre_articulo').setValue('');
                this.getField('ubicacion_origen').setValue('');
                this.getField('ubicacion_destino').setValue('');
            }else{
                //no debería entrar acá
            }
        }else {
          if(data.estado_p===404) {
            this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
          }
          else {
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
          }
        }
      }



    traerPropiedades() {
        let datos = { datos: {
            sucursal_ingreso:this.sucursal_ingreso
        } };
        this.generalFormatPmv = { tipo_servicio: 'inve-saldosporubicacion', operacion: 'traerpropiedades', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerPropiedades,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraerPropiedades(data) {
        this.getField('confirmModalCustom').toggle(false);
        
        if (data.estado_p === 200) {
            this.numero_decimales = data.data.numero_decimales;
            this.wms_nuevo = data.data.wms_nuevo;
            this.trasladar=data.data.trasladar;
            if(this.trasladar){
                this.getField('bt_trasladar').setDisabled(false);
            }
        } else if (data.estado_p === 404) {

            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }



    limpiarCampos() {
        this.getField('codigo_articulo').setError(false,'');
        this.getField('nombre_articulo').setError(false,'');
        this.getField('ubicacion_origen').setError(false,'');
        this.getField('ubicacion_destino').setError(false,'');

        this.getField('rejilla').toggle(false);


        this.getField('ubicacion_destino').setVisible(false);
        this.getField('bt_trasladar').setVisible(false);
    }


    currencyFormatterGeneral(number) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
        if ((decimal !== 0) && (decimal !== undefined)) {
            if (decimal.length > this.numero_decimales) {
                number = number.toFixed(this.numero_decimales); //para que redondea a dos decimales
                decimal = (number + "").split(".")[1];
            }
            return (this.formatNumberSaldo(number) + "," + decimal);
        } else {
            return this.formatNumberSaldo(number);
        }
    }

    formatNumberSaldo(number) {
        return Number(number).toFixed(this.numero_decimales).toString().split('.')[0]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }


    mostrarMensajeGuardando(){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeAdicional(mensaje) {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGenerando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);

    }

    mostrarMensajeNoHayDatos() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    //mensajes correo

    mostrarMensajeEmailEnviado() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Email enviado exitosamente...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeEmailFallo() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', 'Error al enviar el email...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }


}
FormJaivana.addController("inve-saldosporubicacion", CustomSaldosPorUbicacion);
export default CustomSaldosPorUbicacion